import classNames from "classnames";
import styles from "./Editor.module.scss";

/**
 * Editor resizes automaticly to its content if max-height is set.
 * To disable simply set fixed height.
 * Also you may use manualResize prop to enable resize thumb
 **/

type EditorProps = {
  className?: string;
  onInput?: any;
  onPaste?: any;
  validationText?: string;
  successText?: string;
  editorRef?: any;
  invalid?: boolean;
  manualResize?: boolean;
  placeholder?: string;
};

export const Editor = ({
  editorRef,
  manualResize = false,
  invalid = false,
  validationText,
  successText,
  onInput,
  onPaste,
  className,
  placeholder,
}: EditorProps) => {
  const classes = [
    styles.editorWrapper,
    {
      [styles.invalid]: invalid,
      [styles.manualResize]: manualResize,
    },
    className,
  ];

  return (
    <div className={classNames(classes)}>
      <div className={styles.wrapper}>
        {placeholder && !editorRef.current?.textContent && (
          <div className={styles.placeholder}>{placeholder}</div>
        )}
        <div
          className={styles.editor}
          ref={editorRef}
          onInput={onInput}
          onPaste={onPaste}
          spellCheck={false}
          tabIndex={2}
          contentEditable
        />
      </div>
      {successText && <span className={styles.successText}>{successText}</span>}
      {validationText && <span className={styles.validationText}>{validationText}</span>}
    </div>
  );
};
